import { render, staticRenderFns } from "./updated_accounts.vue?vue&type=template&id=3d835910&lang=pug&"
import script from "./updated_accounts.vue?vue&type=script&lang=coffee&"
export * from "./updated_accounts.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports